import { DeliveryImplantInspection } from 'api/models/Deliveries';
import { ImplantsByDelivery } from 'api/models/Implants';
import { SetsByDelivery } from 'api/models/Sets';
import { useCallback } from 'react';

const useFilterCheckOutSetsByDelivery = () =>
  useCallback(
    <T extends SetsByDelivery | ImplantsByDelivery>(
      setsByDelivery: T,
      dataType: 'sets' | 'implants' = 'sets',
      statusOverride?: Record<string, DeliveryImplantInspection>,
    ) => {
      const getStatusStr = (status?: string | { status: string }) =>
        'string' == typeof status ? status : status?.status;

      const validCheckInStatuses = ['CONFIRMED'];
      if (dataType == 'implants') {
        validCheckInStatuses.push('UNCONFIRMED');
      }

      return Object.entries(setsByDelivery).reduce<T>((acc, [deliveryId, sets]) => {
        // apply status overrides
        const checkedOut = !!statusOverride?.[deliveryId]?.CHECK_OUT;
        if (checkedOut) return acc;

        const inspectionsKey = dataType == 'sets' ? 'inspections' : 'inspection';
        const compatibleSets = sets.filter(set => {
          const checkInStatus = getStatusStr(set[inspectionsKey]?.CHECK_IN);
          const checkOutStatus = getStatusStr(set[inspectionsKey]?.CHECK_OUT);
          return checkInStatus && validCheckInStatuses.includes(checkInStatus) && checkOutStatus != 'CONFIRMED';
        });

        if (compatibleSets.length) {
          acc[deliveryId] = compatibleSets;
        }

        return acc;
      }, {} as T);
    },
    [],
  );

export default useFilterCheckOutSetsByDelivery;
